<template>
  <el-container class="app-wrapper" :class="classObj">
    <!-- <mask-view></mask-view> -->
    <el-header class="hreader" height="90px">
      <navbar />
    </el-header>
    <el-container :class="{ hasTagsView: needTagsView }" class="main-container">
      <el-aside class="left-menu">
        <sidebar class="sidebar-container" />
      </el-aside>
      <el-main class="container" ref="container">
        <div :class="{ 'fixed-header': fixedHeader }">
          <tags-view v-if="needTagsView" />
        </div>
        <app-main @scrollToTop="scrollToTop" />
        <el-footer height="50px" class="footer">
          COPYRIGHT © 胖猫网 www.pangmao.com 沪ICP备 13013915号-3 ICP证：沪B2-20140148
        </el-footer>
      </el-main>
    </el-container>
    <div
      class="globel-operate cursor"
      draggable="true"
      :style="{ transform: `translate(${globelX}px, ${globelY}px)` }"
      @dragend="dragend"
      @drag="drag"
      @mousedown="mousedown"
    >
      <div class="globel-operate-items">
        <div
          class="item im item-fg"
          :class="{ 'show-animation': !isClearAllAnimation && showAnimation1 }"
        >
          <div class="child my-msg">
            <el-badge
              :value="unReadCount"
              class="im"
              :max="99"
              :class="{ 'show-animation': !isClearAllAnimation && showAnimation2 }"
              @click.native="showIm"
            >
              <div class="im-icon"></div>
            </el-badge>
            <p class="title">我的消息</p>
          </div>
        </div>
        <div class="item item-fg">
          <div class="child">
            <el-badge
              :value="$store.state.quotation.count || 0"
              class="im"
              :max="99"
              @click.native="toQuotation"
            >
              <img src="@/assets/quotation-icon.png" class="quotation-icon" />
            </el-badge>
            <p class="title">我的资源单</p>
          </div>
        </div>
        <div class="item" @click="showRobot">
          <div class="child fat-cat">
            <p class="title">胖猫</p>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import { AppMain, Navbar, Sidebar, TagsView } from './components'
import { mapState } from 'vuex'
import { getWebToken, getUserId, defaultParams } from '@/common/utils/common'
// import MaskView from './components/MaskView/index'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView
    // MaskView
  },
  data() {
    return {
      timerList: [],
      unReadCount: 0,
      globelX: window.innerWidth - 100,
      globelY: window.innerHeight * 0.5,
      mouseOffsetX: 0,
      mouseOffsetY: 0,
      imVisible: false,
      showAnimation1: false,
      showAnimation2: false,
      isClearAllAnimation: false
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    ...mapState('user', ['userCurrentOrg']),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation
      }
    }
  },
  watch: {
    unReadCount: {
      handler(count, oldCount) {
        if (this.unReadCount && this.timerList.length) return false
        if (!count || oldCount > count || this.imVisible) {
          this.isClearAllAnimation = true
          return false
        }
        this.isClearAllAnimation = false
        const timer = setInterval(() => {
          this.controlAnimationHandler()
          if (this.isClearAllAnimation) {
            clearInterval(timer)
          }
        }, 3500)
        this.timerList.push(timer)
      }
    }
  },
  async mounted() {
    window.IM &&
      window.IM.init({
        wtk: getWebToken() || '',
        uid: getUserId() || '',
        aid: defaultParams.aid.business_pc,
        orgid: this.userCurrentOrg && this.userCurrentOrg.id,
        offsetRight: 100
      })
    window.IM &&
      window.IM.on('unreadMsgChange', (count = 0) => {
        console.log('未读消息', count)
        this.unReadCount = count
      })
    window.IM &&
      window.IM.on('imVisible', visible => {
        this.imVisible = visible
      })

    window.addEventListener('resize', evt => {
      this.globelX = window.innerWidth - 100
    })
    this.$store.dispatch('quotation/getCount')
  },
  methods: {
    showIm() {
      window.IM && window.IM.show()
      this.isClearAllAnimation = true
      this.timerList.forEach(timer => {
        clearTimeout(timer)
      })
      this.timerList = []
    },
    showRobot() {
      window.IM &&
        window.IM.show({
          curWindow: 'robot'
        })
    },
    drag(evt) {
      this.globelX = evt.clientX - this.mouseOffsetX
      this.globelY = evt.clientY - this.mouseOffsetY
    },
    mousedown(evt) {
      this.mouseOffsetY = evt.offsetY
      this.mouseOffsetX = evt.offsetX
    },
    dragend(evt) {
      this.globelX = window.innerWidth - 100
      this.globelY = evt.clientY - this.mouseOffsetY
      if (this.globelY < 100) {
        this.globelY = 100
      }
      if (this.globelY > window.innerHeight - 150) {
        this.globelY = window.innerHeight - 150
      }
    },
    scrollToTop() {
      const $container = this.$refs['container']
      if ($container) {
        $container.$el.scrollTop = 0
      }
    },
    // 去资源单
    toQuotation() {
      this.$router.push({
        name: 'quotation'
      })
    },
    delay(ms, callback) {
      return new Promise(resolve => {
        const timer = setTimeout(() => {
          resolve(callback())
          clearTimeout(timer)
        }, ms)
      })
    },
    controlAnimationHandler() {
      this.showAnimation1 = true
      this.delay(2000, () => {
        this.showAnimation1 = false
        this.delay(600, () => {
          this.showAnimation2 = true
          this.showAnimation1 = false
        })
      })
      this.delay(3400, () => {
        this.showAnimation2 = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/common/styles/mixin.scss';
@import '~@/common/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  min-width: 1280px;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
  .hreader {
    padding: 0;
  }
  .container {
    padding: 0;
  }
  .main-container {
    @media all and (min-width: $maxWidth) {
      margin-left: calc(50vw - 720px);
    }
  }
  .app-main {
    max-width: $maxWidth - $sideBarWidth;
  }
  .left-menu {
    padding: 0;
    width: $sideBarWidth !important;
    margin-bottom: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: absolute;
  top: 0;
  left: $sideBarWidth;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
.footer {
  line-height: 50px;
  text-align: center;
  color: #666;
  font-size: 12px;
}
.globel-operate {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  // transition: transform .5s;
  &-items {
    background: rgba(252, 252, 252, 1);
    border: 1px solid rgba(240, 240, 240, 1);
  }
  .item {
    width: 76px;
    height: 76px;
    position: relative;
    &.show-animation {
      animation: fadeBgInOut 2s infinite 0.16s;
    }
  }
  .item-fg {
    border-bottom: 1px solid rgba(240, 240, 240, 1);
  }

  .quotation-icon {
    height: 24px;
    width: 24px;
    margin-bottom: 3px;
  }

  .child {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
    &.my-msg {
      .im.show-animation {
        /deep/ .el-badge__content--undefined {
          animation: zoomInOut 0.6s infinite 0.2s;
        }
      }
      .im-icon {
        width: 20px;
        height: 30px;
        position: relative;
        color: #333;
        background: url('../assets/im.svg') no-repeat center 0px;
      }
      &:hover {
        .im-icon {
          background: url('../assets/im_active.svg') no-repeat center 0px;
        }
        .title {
          color: #cd974c;
        }
      }
      /deep/ .el-badge__content--undefined {
        top: 4px;
      }
    }
    &.fat-cat {
      height: 41px;
      position: relative;
      color: #333;
      background: url('../assets/robot.svg') no-repeat center 0px;
      .title {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%);
      }
      &:hover {
        background: url('../assets/robot_active.svg') no-repeat center 0px;
        .title {
          color: #cd974c;
        }
      }
    }
  }

  .title {
    color: rgba(51, 51, 51, 1);
    font-size: 12px;
  }
  /deep/.el-badge__content {
    background-color: #cd974c;
    height: auto;
    line-height: 0;
    padding: 8px 6px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
  }
}
@keyframes zoomInOut {
  0% {
    padding: 8px 6px;
    font-size: 12px;
    border-radius: 10px;
  }
  25% {
    padding: 10px 7px;
    font-size: 14px;
    border-radius: 18px;
  }
  50% {
    padding: 8px 6px;
    font-size: 12px;
    border-radius: 10px;
  }
  75% {
    padding: 10px 7px;
    font-size: 14px;
    border-radius: 18px;
  }
  100% {
    padding: 8px 6px;
    font-size: 12px;
    border-radius: 10px;
  }
}
@keyframes fadeBgInOut {
  0% {
    background-color: #fff;
  }
  8% {
    background-color: #fcecec;
  }
  16% {
    background-color: #fff;
  }
  24% {
    background-color: #fcecec;
  }
  32% {
    background-color: #fff;
  }
  40% {
    background-color: #fcecec;
  }
  48% {
    background-color: #fff;
  }
  56% {
    background-color: #fcecec;
  }
  64% {
    background-color: #fff;
  }
  72% {
    background-color: #fcecec;
  }
  80% {
    background-color: #fff;
  }
  88% {
    background-color: #fcecec;
  }
  100% {
    background-color: #fff;
  }
}
</style>
